import { render, staticRenderFns } from "./ConsultasListagemTabela.vue?vue&type=template&id=94735484&scoped=true"
import script from "./ConsultasListagemTabela.vue?vue&type=script&lang=js"
export * from "./ConsultasListagemTabela.vue?vue&type=script&lang=js"
import style0 from "./ConsultasListagemTabela.vue?vue&type=style&index=0&id=94735484&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94735484",
  null
  
)

export default component.exports